/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import CheckIcon from "@/src/assets/icons/common/toggleable/IconCheck";
import CrossIcon from "@/src/assets/icons/common/toggleable/IconClose";
import { Box, MenuItem } from "@mui/material";
import { useForm } from "@/src/provider/Form/FormProvider";
import Group from "@/src/components/Wizard/Group";
import { requiredValidator } from "@/src/services/validationRules";
import ValidatorSelectField from "@/src/components/FormFields/ValidatorSelectField";
import Typography from "@mui/material/Typography";
import NumberFieldConfigured from "@/src/components/Form/ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import wizardStyle from "@/src/components/Form/wizardStyle";

type MobilityCostDeductionProps = {
  submitProps: FormSubmitProps;
};

export default function MobilityCostDeduction({ submitProps }: MobilityCostDeductionProps) {
  const { values, handleSubmit } = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={wizardStyle.wizardForm} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Ausgaben
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type={"radio"}
                name={"hasMobilityCostDeduction"}
                question={"Haben Sie Fahrtkosten für den Weg zur Arbeit?"}
                modalContent={<p>Unter die Fahrtkosten fallen zum Beispiel Kosten für den öffentlichen Nahverkehr oder Fahrten mit dem privaten PKW.</p>}
                options={[
                  {
                    labelText: "Nein",
                    labelIcon: <CrossIcon />,
                    labelIconActive: <CrossIcon active />,
                    value: "no",
                  },
                  {
                    labelText: "Ja",
                    labelIcon: <CheckIcon />,
                    labelIconActive: <CheckIcon active />,
                    value: "yes",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
            {values.hasMobilityCostDeduction === "yes" && (
              <>
                <Grid size={12}>
                  <ValidatorSelectField
                    label={"Verkehrsmittel"}
                    name={`mobilityCostUnit`}
                    validators={[requiredValidator("Bitte geben Sie das Verkehrsmittel an")]}
                    MenuProps={{ slotProps: { paper: { style: { maxHeight: 200 } } } }}
                  >
                    <MenuItem value={"km"}>Mit dem eigenen Auto</MenuItem>
                    <MenuItem value={"€"}>Mit öffentlichen Verkehrsmitteln</MenuItem>
                  </ValidatorSelectField>
                </Grid>
                {values.mobilityCostUnit && (
                  <NumberFieldConfigured
                    caseData={values}
                    fieldPath={"mobilityCostAmount"}
                    fieldType={values.mobilityCostUnit === "km" ? null : "money"}
                    numberType={"float"}
                    required
                  />
                )}
              </>
            )}
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
